// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"367":"906580516606d72e","944":"b19b8a33c33e62f7"}[chunkId] + ".js";
};